export enum ControlState {
    FormEdit = 0, //this is a embedded form which allows the user to modify the content
    FormView, //this is read only version with (some) read only tools enabled (e.g. history)
    DialogCreate, //this allows the user to modify the content, usually to create new elements. No tools
    HistoryView, //is a read only version, e.g. used for the history where smart text and smart link is not resolved
    Tooltip, // most things will not shown as tooltip...
    Print, // for printing ...
    Report, // special to render report into page
    DialogEdit, // between FormEdit and DialogCreate to edit an item in popup
    Review, // special mode for design reviews
    Zen, // zen mode
}
